import $ from 'jquery';
import ko from 'knockout';
import templateMarkup from 'raw-loader!./multicell-widget.html';


  function MulticellWidget(params) {
      var self = this;
      this.observableOptions = params.observableOptions;
      this.observableData = params.observableData;
      self.panelTemplate = params.panelTemplate;
      self.widgetSignals = params.widgetSignals;

      self.cells = ko.observableArray([]);

      self.dataLoaded = ko.observable(false);
      self.RefreshData();

      self.subscriptions = [];
      self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
      //self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));
  }


    MulticellWidget.prototype.RefreshData = function () {
        var self = this;

        var data = self.observableData();

        if (!$.isEmptyObject(data)) {

            if (!data.cells) {
                return;
            }

            self.cells(data.cells);
            self.dataLoaded(true);

            if (self.widgetSignals) {
                self.widgetSignals.dataLoaded.dispatch();
            }
        }
    };

    MulticellWidget.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    MulticellWidget.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };


  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    MulticellWidget.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

  export default { viewModel: MulticellWidget, template: templateMarkup };
